import { render, staticRenderFns } from "./ScoreLinksList.vue?vue&type=template&id=6c06b4a0&"
import script from "./ScoreLinksList.vue?vue&type=script&lang=js&"
export * from "./ScoreLinksList.vue?vue&type=script&lang=js&"
import style0 from "./ScoreLinksList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports